export default {
  'voucher': '入场凭证',
  'moduleName': '为同事预登记',
  'addButton': '开始预登记',
  'table': {
    'name': '姓名',
    'email': '邮箱',
    'confirmation': '入场凭证',
    'badge': '电子胸卡',
    'createTime': '创建时间',
    'status': '审核状态'
  },
  'dialogBadgeTitle': '下载胸卡',
  'dialogBadgeSubTitle': '您可以在此下载胸卡',
  'BUYER': 'BUYER 买家',
  'PurChasing-Agent': 'PurChasing Agent 采购买家',
  'dialogCTitle': '下载入场凭证',
  'dialogCSubTitle': '您可以在此下载入场凭证',
  'groupTips1': '您已注册成功，请凭此二维码入场',
  'groupTips2': '已为您开启线上展所有访问权限',
  'groupTips3': '在线交互接洽，一触解决供销难题',
}